<template lang="pug">
  .col-24.flexD.alignItemsCenter.justifyCenter.l-padding-top-8em.l-padding-bottom-4em.m-padding-top-4em.m-padding-bottom-0.initBackgroundImage(:style="{backgroundImage:'url('+ img.bg +')', backgroundSize: 'contain', backgroundPosition: 'top'}")
    .col-12.flexD.flexDirectionColumn.minWidth700.m-minWidthAuto.m-width-100
      .col-24.flexD.justifyCenter.l-margin-bottom-4em
        .col-8.m-width-40
          img.col-24.block(:src="img.logo")
      .col-24.l-margin-bottom-4em.m-padding-left-right-5p
        .font-section.textAlignLeft(v-for="(item, index) in section" :key="index") {{ item.content }}
      .col-24.l-margin-bottom-4em.flexD.flexDirectionRow.justifySpaceBetween.alignItemsCenter.m-flexDirectionColumn.m-margin-bottom-2em
        .col-11.m-width-100.m-height-30vh.initBackgroundImage(:style="{backgroundImage:'url('+ items[0].img +')', backgroundPosition: 'top'}")
          img.block.col-24.objectFitCover.m-hidden-important(:src="items[0].img")
        .col-12.textAlignLeft.m-width-90.m-margin-top-2em
          .font-title-small.l-margin-bottom-2em.m-textAlignCenter {{ items[0].title }}
          .font-section.color-font-middGary.lineHeightOneHalfEM {{ items[0].content }}
      .col-24.l-margin-bottom-4em.flexD.flexDirectionRowReverse.justifySpaceBetween.alignItemsCenter.m-flexDirectionColumn.m-margin-bottom-2em
        .col-10.m-width-100.m-height-30vh.initBackgroundImage(:style="{backgroundImage:'url('+ items[1].img +')', backgroundSize: 'cover'}")
          img.block.col-24.objectFitCover.m-hidden-important(:src="items[1].img")
        .col-12.textAlignLeft.m-width-90.m-margin-top-2em
          .font-title-small.l-margin-bottom-2em.m-textAlignCenter {{ items[1].title }}
          .font-section.color-font-middGary.lineHeightOneHalfEM {{ items[1].content }}
          ul.font-ul.color-font-middGary.lineHeightOneHalfEM
            li(v-for="(item, index) in items[1].list" :key="index") {{ item.text }}
      //-   .font-section.textAlignLeft(v-for="(item, index) in text.section" :key="index") {{ item.content }}
      .col-24.l-margin-bottom-4em.msFlexNegative
        video.block.col-24(:src="video.wellve" controls="controls" :poster="img.poster")
      .col-24.flexD.justifyCenter.l-margin-bottom-2em
        a.font-section.color-font-deepRed.fontBold.cursorPointer.textDecorationNone(:href="more.url" target="_blank")
          | {{ more.text }}
          i.fa.fa-arrow-circle-o-right.l-margin-left-10
</template>

<script>
  export default {
    name: 'wellve',
    props: ['content'],
    data(){
      return{
        section: [
          {content: this.$t('wellve.content')}
        ],
        items: [
          {title: this.$t('wellve.title_1'), content: this.$t('wellve.content_1'), img: require('@/assets/img/wellve/wellve_1.jpg')},
          {title: this.$t('wellve.title_2'), content: this.$t('wellve.content_2'), img: require('@/assets/img/wellve/wellve_2.jpg'), list: [
            {text: this.$t('wellve.list_1')},
            {text: this.$t('wellve.list_2')},
            {text: this.$t('wellve.list_3')},
            {text: this.$t('wellve.list_4')},
            {text: this.$t('wellve.list_5')},
          ]},
        ],
        img: {
          logo: require('@/assets/img/logo/logo_wellve.png'),
          poster: require('@/assets/img/cover_wellve.jpg'),
          bg: require('@/assets/img/bg_wellve.png')
        },
        video: {
          wellve: require('@/assets/media/wellve.mp4')
        },
        more: {
          text: this.$t('wellve.more'),
          url: 'https://wellve.ch/products/wellve-mobiles-entspannungsgerat-mit-vibroakustik'
        }
      }
    },
    computed: {},
    methods:{},
    created(){}
  }
</script>
